import getUsers from "./getUsers"
import getProfile from "./getProfile"
import getUser from "./getUser"

export { getUsers, getProfile, getUser }

const user = { getUsers, getProfile, getUser }

export default user
